<template>
  <div id="product-list-components">
    <div class="viewType">
      <!-- view zoom -->
      <div class="zoom">
        <button type="button" class="btnZoomOut" @click="zoom -= 1" :disabled="zoom <= 1"></button>
        <!-- <span class="zoomStatus">X{{ zoom }}</span> -->
        <button type="button" class="btnZoomIn" @click="zoom += 1" :disabled="zoom >= 4"></button>
      </div>
      <!-- //view zoom -->
      <span class="type" data-type="grid">
        <input type="radio" name="view_type" id="view_type_grid" value="grid" v-model="productViewType">
        <label for="view_type_grid"></label>
      </span>
      <span class="type" data-type="list">
        <input type="radio" name="view_type" id="view_type_list" value="list" v-model="productViewType">
        <label for="view_type_list"></label>
      </span>
    </div>
    <!-- product sort -->
    <div v-if="isSort" class="sorting mt10 notranslate">
      <select class="input inlineInput select" v-model="sortKey">
        <option v-for="(sort, index) in sorting" :key="index" :value="sort">{{locale[`sortby_${sort}`]}}</option>
      </select>
    </div>
    <!-- //product sort -->
    <!-- <div v-if="list.length"
      class="list"
      :data-view_type="productViewType"
      :data-zoom="zoom">
      <ProductItem v-for="item in list"
        :key="item.id"
        :lang="lang"
        :locale="locale"
        :item="item"
        :isAuth="isAuth"
        :roomKey="roomKey"
        :place="place"
        @addCart="addCart"
        @setDetail="setDetail" />
    </div> -->
    <div v-if="list && list.length">
      <div v-if="listType === 'uncategorized'"
        class="list"
        :data-view_type="productViewType"
        :data-zoom="zoom">
        <ProductItem v-for="item in list"
          :key="item.id"
          :lang="lang"
          :responsive="responsive"
          :locale="locale"
          :item="item"
          :isAuth="isAuth"
          :roomKey="roomKey"
          :place="place"
          :setDefaultImage="setDefaultImage"
          @addCart="addCart"
          @setDetail="setDetail" />
      </div>
      <div v-else-if="listType === 'categorized'">
        <div
          v-for="itemGroup in list"
          :key="itemGroup.id"
          :data-group="itemGroup.id"
          :data-group_item="itemGroup.ids"
          class="itemGroup">
          <div class="groupName">
            <span
              v-for="(name, index) in itemGroup.label"
              :key="index"
              :class="{last: index === itemGroup.label.length - 1}">
              {{ name }}
            </span>
          </div>
          <div
            v-if="itemGroup.items && itemGroup.items.length"
            :data-view_type="productViewType"
            :data-zoom="zoom"
            class="list">
            <ProductItem
              v-for="item in itemGroup.items"
              :key="item.id"
              :lang="lang"
              :responsive="responsive"
              :locale="locale"
              :viewCart="viewCart"
              :item="item"
              :isAuth="isAuth"
              :roomKey="roomKey"
              :place="place"
              :setDefaultImage="setDefaultImage"
              @addCart="addCart"
              @setDetail="setDetail"
              @setToastMessage="setToasetMessage" />
          </div>
          <p v-else class="noData notranslate">{{locale.product_nodata}}</p>
        </div>
      </div>
    </div>
    <p v-else class="noData notranslate">{{loadData ? locale.product_nodata : locale.data_loading}}</p>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
    <ToastMessage v-if="toastMessage"
      :locale="locale"
      :message="toastMessage"
      @close="setToasetMessage(null)" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import ProductItem from '@/components/Product/ProductItem.vue'
import Toast from '@/components/Util/Toast'
import ToastMessage from '@/components/Util/ToastMessage'

export default {
  name: 'ProductList',
  props: [
    'lang',
    'responsive',
    'locale',
    'roomKey',
    'list',
    'listType',
    'loadData',
    'viewType',
    'place',
    'activeSort', // 소팅 여부
    'displaySort', // 소팅 노출 여부
    'sortby', // 소트바이
    'viewCart', // 플로팅 장바구니 상태
    'setDefaultImage' // 기본 이미지 사용 여부
  ],
  components: {
    ProductItem,
    Toast,
    ToastMessage
  },
  computed: {
    ...mapGetters({
      getAuthInfo: 'authentication/getAuthInfo',
      getCartListData: 'cart/getList'
    }),
    isPublic () {
      return this.getAuthInfo.public === 'true'
    },
    productViewType: {
      get () {
        return this.viewType
      },
      set (type) {
        this.$emit('setViewType', type)
      }
    },
    isSort () {
      return this.activeSort && this.displaySort
    },
    sortKey: {
      get () {
        return this.sortby
      },
      set (sortby) {
        this.$emit('setSortby', sortby)
      }
    }
  },
  watch: {
    zoom (zoomLevel) {
      this.setZoom(zoomLevel)
    },
    getCartListData: {
      deep: true,
      handler (list) {
        this.getCartList()
      }
    }
  },
  created () {
    this.getCartList()
    this.initZoom()
  },
  async mounted () {
    await this.getKey()
  },
  data () {
    return {
      cartList: [],
      cartData: null,
      isAuth: false,
      key: this.$store.state.authentication.k,
      sorting: [
        'price_desc',
        'price_asc',
        'name_asc',
        'name_desc',
        'created'
      ],
      toastList: [],
      zoom: 1,
      toastMessage: null
    }
  },
  methods: {
    async getKey () {
      if (this.isPublic) {
        const res = await this.$store.dispatch('authentication/getOtaKey')
        this.key = res
      }
      this.checkAuth()
    },
    initZoom () {
      const site = this.$store.state.authentication.site
      const zoomLevel = localStorage.getItem(`${site}_product_zoom`) || 1
      this.zoom = zoomLevel
    },
    setZoom (zoom) {
      const site = this.$store.state.authentication.site
      const zoomLevel = zoom || 1
      localStorage.setItem(`${site}_product_zoom`, zoomLevel)
    },
    checkAuth () {
      const getAuthInfo = this.$store.getters['authentication/getAuthInfo']
      const key = this.key
      const space = getAuthInfo.space
      const hasKey = !!key && key !== 'undefined'
      const hasSpace = !!space && space !== 'undefined'
      const isKeyValid = !(getAuthInfo.otavalid && getAuthInfo.otavalid === 'false')
      this.isAuth = hasKey && hasSpace && isKeyValid
    },
    getCartList () {
      this.cartList = []
      if (localStorage.length > 0) {
        for (let i = 0; i < localStorage.length; i++) {
          // cart_pageId로 시작하는 items
          if (localStorage.key(i).includes('cart_')) {
            const cartItem = JSON.parse(localStorage.getItem(localStorage.key(i)))
            this.cartList.push({ ...cartItem, cartId: localStorage.key(i) })
            // this.cartData = this.cartList.find(x => x.pageId === this.getPage.id) || {}
          }
        }
      }
    },
    getMergeItem (existItem, addedItem) {
      const existQuantity = existItem.price.info.quantity
      const priceInfo = addedItem.price.info
      addedItem.cartId = existItem.cartId
      addedItem.order = existItem.order
      priceInfo.quantity += existQuantity
      priceInfo.total = priceInfo.price * priceInfo.quantity
      addedItem.content.find(x => x.type === 'quantity').value = priceInfo
      return addedItem
    },
    addToast (trigger, type, message) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = this.toastList.filter(x => x.id !== id)
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'addCart') {
            this.addCartItem(data.id)
          } else if (trigger === 'addCartExist') {
            this.addCartItemExist(data.id)
          } else if (trigger === 'goCartPage') {
            this.goCartPage(data.id)
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    addCart (data) {
      this.cartData = data.cartData
      this.onSubmit()
    },
    setDetail (data) {
      this.$emit('setDetail', data)
    },
    // 새로 장바구니에 추가
    addCartItem (id) {
      /**
       * submitData.info.available (this.pageInfo.available)는
       * 이용가능시간 전체 정보가 아닌
       * 현재시각 기준으로 데이터가 가공 되어 있기 때문에
       * 장바구니에는 전체 정보가 필요함
      */
      const cartIdx = this.cartList.length
      const cartData = Object.assign(this.cartData, { order: cartIdx })
      const cartId = `cart_${UNIQUE.fileid()}_${cartData.productId}_${cartData.productItemId}`
      const cartContent = JSON.stringify(cartData)
      const cartItem = {
        cartId: cartId,
        ...cartData
      }
      localStorage.setItem(cartId, cartContent)
      this.$store.commit('cart/addList', cartItem)
      this.getCartList()
      this.delToast(id)
      if (this.responsive === 'tablet') {
        this.$emit('setViewCart', true)
        this.setToasetMessage(this.locale.complete_cart_add)
      } else {
        this.addToast('goCartPage', 'confirm', `${this.locale.complete_cart_add}\n${this.locale.confirm_cart_page}`)
      }
    },
    setToasetMessage (message) {
      this.toastMessage = message
    },
    addCartItemExist (id) {
      const cartIdx = this.cartList.length
      const cartData = Object.assign(this.cartData, { order: cartIdx })
      const cartList = this.cartList
      const existItem = cartList.find(x => x.productItemId === cartData.productItemId)
      const addedItem = this.getMergeItem(existItem, cartData)
      localStorage.setItem(addedItem.cartId, JSON.stringify(addedItem))
      this.$store.commit('cart/addList', addedItem)
      this.getCartList()
      this.delToast(id)
      if (this.responsive === 'tablet') {
        this.$emit('setViewCart', true)
        this.setToasetMessage(this.locale.complete_cart_add)
      } else {
        this.addToast('goCartPage', 'confirm', `${this.locale.complete_cart_add}\n${this.locale.confirm_cart_page}`)
      }
    },
    goCartPage (id) {
      const lang = this.lang
      this.delToast(id)
      this.$router.push({ name: 'cart', params: { lang: lang } })
    },
    onSubmit () {
      const cartIdx = this.cartList.length
      const cartData = Object.assign(this.cartData, { order: cartIdx })
      const cartList = this.cartList
      const existItem = cartList.find(x => x.productItemId === cartData.productItemId)
      // const confirmMessage = existItem ?  : this.locale.confirm_cart_add
      if (existItem) { // 이미 장바구니에 상품이 존재할 때 기존 장바구니와 합친다
        // this.addToast('addCartExist', 'confirm', `${this.locale.confirm_cart_add_already}\n${this.locale.confirm_cart_add}`)
        this.addCartItemExist()
      } else { // 새로 장바구니에 추가
        // this.addToast('addCart', 'confirm', this.locale.confirm_cart_add)
        this.addCartItem()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.viewType {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 15px;
  padding-right: 15px;
  text-align: right;
  .type {
    display: inline-block;
    vertical-align: middle;
    label {
      display: block;
      padding: 4px;
      border: 1px solid $color-lgrey;
      cursor: pointer;
      &:before {
        content: "";
        display: block;
        width: 24px;
        height: 24px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        opacity: 0.15;
      }
    }
    & + .type {
      margin-left: 5px;
    }
    :checked+label {
      border-color: $color-dark;
      &:before {
        opacity: 0.75;
      }
    }
  }
  .zoom {
    margin-right: 15px;
    .btnZoomIn,
    .btnZoomOut {
      width: 24px;
      height: 24px;
      background: url('~@/assets/img/ico_zoomin.png') 50% 50% / contain no-repeat;
      opacity: 0.7;
      &:disabled {
        opacity: 0.3;
      }
    }
    .btnZoomOut {
      margin-right: 8px;
      background-image: url('~@/assets/img/ico_zoomout.png');
    }
    .zoomStatus {
      margin: 0 4px;
      font-size: 14px;
      color: $color-grey;
    }
  }
  [data-type="grid"] label:before {
    background-image: url('~@/assets/img/ico_grid.png');
  }
  [data-type="list"] label:before {
    background-image: url('~@/assets/img/ico_list.png');
  }
}
.sorting {
  margin-bottom: -10px;
  padding-left: 15px;
  padding-right: 15px;
  font-size: 12px;
  text-align: right;
  .select {
    min-height: 0;
    padding: 0.2em 0.5em;
  }
}
@media screen and (min-width: 1024px) {
  .viewType {
    padding-top: 30px;
    padding-right: 30px;
  }
  .product .list {
    padding: 15px 22px 60px;
  }
}
</style>
